<template>
  <v-dialog :value="show" width="640">
    <div class="wrapper">
      <div class="calender-wrapper">
        <PickerDate v-model="range.startDate" />
        <PickerDate v-model="range.endDate" />
      </div>
      <div class="decision">
        <v-btn @click="apply" color="primary">決定</v-btn>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import PickerDate from './PickerDate'
import dayjs from 'dayjs'

export default {
  name: 'ModalPickerPeriodRange',
  components: { PickerDate },
  props: {
    // Range
    value: {
      type: Object,
      required: true,
    },
    show: {
      Boolean,
      default: false,
    },
  },
  data() {
    return {
      range: cloneDeep(this.value),
    }
  },
  methods: {
    apply() {
      const { startDate, endDate } = this.range
      const range = dayjs(startDate).isBefore(endDate)
        ? {
            startDate,
            endDate,
          }
        : {
            startDate: endDate,
            endDate: startDate,
          }
      this.$emit('input', range)
      this.closeModal()
    },
    closeModal() {
      this.$emit('hide')
    },
  },
}
</script>

<style scoped lang="scss">
.calender-wrapper {
  display: flex;
  justify-content: space-around;
  align-content: center;
}
.wrapper {
  padding: 20px 10px 10px;
  background: white;
}

.decision {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.selected-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}
.selected-date {
  font-size: 32px;
}
</style>
